class Countdown {
    constructor(seconds, callback) {
        this.seconds = seconds;
        this.callback = callback;
        this.timerId = null;
    }

    start() {
        if (this.timerId) {
            clearInterval(this.timerId);
        }

        this.timerId = setInterval(() => {
            if (this.seconds > 0) {
                this.seconds--;
                this.callback(this.seconds);
            } else {
                clearInterval(this.timerId);
            }
        }, 1000);
    }

    stop() {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }

    reset(seconds) {
        this.stop();
        this.seconds = seconds;
    }
}

export default Countdown;
